import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  Actions,
  Column,
  Intro,
  PrimaryButton,
  Subtitle,
  Title,
} from 'components/layout/Auth/AuthForm/styles';

const Concluido: React.FC = () => {
  const history = useHistory();

  return (
    <Column gap={24}>
      <Intro>
        <Title>Tudo pronto!</Title>
        <Subtitle>Sua senha foi alterada com sucesso!</Subtitle>
      </Intro>
      <Actions>
        <PrimaryButton
          type="button"
          shape="pill"
          fullWidth
          onClick={() => history.push('/')}
        >
          Ir para o Portal Minha Ultragaz
        </PrimaryButton>
      </Actions>
    </Column>
  );
};

export default Concluido;
